import { render } from "./Paginacao.vue?vue&type=template&id=0ffb114c&ts=true"
import script from "./Paginacao.vue?vue&type=script&lang=ts"
export * from "./Paginacao.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__